import { useCallback, useEffect, useState } from 'react';

import cls from 'classnames';

import { Placements, Tooltip } from '@picsart/design-system/components/Tooltip';
import { Carousel } from '@picsart/design-system/components/Carousel';

import { useTranslator } from '@picsart/rc/services/localization';
import useDevice from '@picsart/rc/useDevice';

import ColorRectangle from './ColorRectangle';

import { ColorsCarouselProps } from './types';

import useStyles from './styles';

function ColorCarousel({ colors, className, rectangleClassName }: ColorsCarouselProps) {
  const { isMobile } = useDevice();
  const translate = useTranslator();
  const classes = useStyles();
  const [tooltipVisible, setTooltipVisible] = useState(isMobile);

  const hideTooltip = useCallback(() => {
    setTooltipVisible(false);
  }, []);

  useEffect(() => {
    window.addEventListener('click', hideTooltip);

    return () => {
      window.removeEventListener('click', hideTooltip);
    };
  }, []);

  return (
    <div className={cls(classes.root, className)} data-testid="colors-carousel">
      <Carousel isMultiSlide hidePagination>
        {colors.map(data => {
          if (data && data?.colorData) {
            return (
              <ColorRectangle {...data} key={data.colorData.hex} className={rectangleClassName} />
            );
          }
          return null;
        })}
      </Carousel>

      <div className={classes.tooltip}>
        <Tooltip isOpen={tooltipVisible} placement={Placements.Bottom} target={<div />}>
          <div className={classes.tooltipText}>{translate('Tap to see the color name')}</div>
        </Tooltip>
      </div>
    </div>
  );
}

export default ColorCarousel;
